import React from 'react';
import CurricularClass52023 from 'views/CurricularClass52023';

const ExtraCurricularActivitiesPage = () => {
  return <CurricularClass52023 />;
};

export default ExtraCurricularActivitiesPage;
